import { lazy, Suspense, Fragment } from "react"
import { Switch, Route } from "react-router-dom"

// Layout
import DefaultLayout from "./layouts/default"

const routesConfig = [
	{
		path: "/",
		layout: DefaultLayout,
		component: lazy(() => import("./views/home")),
	},
]

const renderRoutes = routes =>
	routes ? (
		<Suspense fallback={<div />}>
			<Switch>
				{routes.map((route, i) => {
					const Guard = route.guard || Fragment
					const Layout = route.layout || Fragment
					const Component = route.component

					return (
						<Route
							key={i}
							path={route.path}
							exact={route.exact}
							render={props => (
								<Guard>
									<Layout>
										{route.routes ? renderRoutes(route.routes) : <Component {...props} />}
									</Layout>
								</Guard>
							)}
						/>
					)
				})}
			</Switch>
		</Suspense>
	) : null

function Routes() {
	return renderRoutes(routesConfig)
}

export default Routes
